import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "suggestion-link"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["suggestion pointer", {selected: $props.selected}])
  }, [
    _createVNode(_component_Image, {
      size: "2.4rem",
      name: $options.c_name,
      src: $props.suggestion.avatar_url,
      "initials-size": "1.3rem",
      shape: "circle"
    }, null, 8 /* PROPS */, ["name", "src"]),
    _createVNode(_component_Ellipsis, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString($props.suggestion.display_name) + " ", 1 /* TEXT */),
        ($options.link)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString($options.link) + ") ", 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    ($props.checkIcon)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          class: "check",
          icon: "check",
          size: "1.6rem",
          stroke: "var(--brand-500)"
        }))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}